import React from 'react';
import PropTypes from 'prop-types';
import { Container, Carousel, classNames } from '@pella/sash-framework';
import { CTA } from '../../';
import { isValidArray } from '../../utilities/validations';
import BaseCard from '../card';

const CardSlider = ({ data, containerWidth, className }) => {
	if (!data || !isValidArray(data?.items)) return null;

	const { heading, subheading, carousel_background, items, ctas } = data;

	const classes = classNames({
		'cardSlider py-10 md:py-16': true,
		'bg-neutral-50': carousel_background === 'gray',
		'bg-white': carousel_background === 'white' || !carousel_background,
		'bg-neutral-750': carousel_background === 'dark gray',
		[className]: className,
	});

	const headingClasses = classNames({
		'cardSlider-heading text-center mb-7 md:mb-12': true,
		'text-white': carousel_background === 'dark gray',
	});

	const subheadingClasses = classNames({
		'cardSlider-subheading text-centermb-12 mx-auto md:max-w-[900px]': true,
		'text-neutral-200': carousel_background === 'dark gray',
	});

	return (
		<div
			className={classes}
			data-testid='card-slider'
		>
			<Container width={containerWidth}>
				{heading && <h2 className={headingClasses}>{heading}</h2>}
				{subheading && <p className={subheadingClasses}>{subheading}</p>}

				<Carousel
					className='cardSlider-carousel'
					slidesToShow={{ xs: 1, sm: 2, lg: 3 }}
					slidePadding={16}
					showArrows
				>
					{items.map((item, index) => (
						<React.Fragment key={index}>
							<div
								key={index}
								className='h-full'
							>
								<BaseCard
									className='cardSlider-card'
									data={item}
								/>
							</div>
						</React.Fragment>
					))}
				</Carousel>

				{isValidArray(ctas) && (
					<div className='mt-7 text-center md:mt-12'>
						<CTA data={ctas[0]} />
					</div>
				)}
			</Container>
		</div>
	);
};

CardSlider.propTypes = {
	data: PropTypes.object,
	containerWidth: PropTypes.number,
	className: PropTypes.string,
};

export default CardSlider;
